import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
} from "@chakra-ui/react";
import { signOut } from "api/auth";
import { useAuth } from "providers/AuthProvider";
import React, { ReactNode } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link as RouteLink } from "react-router-dom";
import Sidebar from "./main/Sidebar";
import { Toolbar } from "./main/Toolbar";

type MainLayoutProps = {
  children?: ReactNode;
};

function MainLayout({ children }: MainLayoutProps) {
  const auth = useAuth();

  return (
    <Flex minH="100vh" direction="column">
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        p={3}
        px={8}
        boxShadow="md"
        bg="teal.500"
        color="white"
      >
        <Flex align="center" mr={5}>
          <Heading as="h1" size="lg" letterSpacing={"-.1rem"}>
            Cura Lab
          </Heading>
        </Flex>
        <Box>
          <Menu>
            <MenuButton
              as={Button}
              outline="none"
              colorScheme="white"
              rightIcon={<FaChevronDown />}
            >
              <Flex alignItems="center">{auth?.lab?.name}</Flex>
            </MenuButton>
            <MenuList color="black">
              <Link as={RouteLink} to="/profile">
                <MenuItem>Profile</MenuItem>
              </Link>
              <MenuItem
                onClick={(_) => {
                  signOut();
                }}
              >
                Logout
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </Flex>
      <Stack flexGrow={1} direction="row" bg="gray.100">
        <Box minW="250px" w="250px" p={2} bg="white" boxShadow="base">
          <Stack spacing={1}>
            <Link as={RouteLink} p={1} to="/patients" px={2} borderRadius={6}>
              Active Patients
            </Link>
            <Link as={RouteLink} to="/tests" p={1} px={2} borderRadius={6}>
              Tests
            </Link>
            <Link
              as={RouteLink}
              p={1}
              to="/appointments"
              px={2}
              borderRadius={6}
            >
              Appointments
            </Link>
            <Link
              as={RouteLink}
              p={1}
              to="/transactions"
              px={2}
              borderRadius={6}
            >
              Transactions
            </Link>
            <Link as={RouteLink} p={1} to="/categories" px={2} borderRadius={6}>
              Categories
            </Link>
            <Link as={RouteLink} p={1} to="/services" px={2} borderRadius={6}>
              Services
            </Link>
            <Link
              as={RouteLink}
              p={1}
              to="/discountcards"
              px={2}
              borderRadius={6}
            >
              Discount card
            </Link>
            <Link as={RouteLink} p={1} to="/reviews" px={2} borderRadius={6}>
              Reviews
            </Link>
          </Stack>
        </Box>
        <Flex p={4} flexGrow={1} alignItems="stretch">
          {children}
        </Flex>
      </Stack>
    </Flex>
  );
}

export default function Layout({ children }: MainLayoutProps) {
  return (
    <Flex h="100%">
      <Sidebar />
      <Divider orientation="vertical" />
      <Box flexGrow={1}>
        <Flex direction="column">
          <Toolbar />
          <Divider />
          <Box flexGrow={1}>{children}</Box>
        </Flex>
      </Box>
    </Flex>
  );
}
